
import { useState } from 'react';

const NewsListSection = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const allNews = [
    {
      date: '2025.01.15',
      category: 'お知らせ',
      title: '年末年始の診療時間のお知らせ',
      content: '2025年12月29日から2026年1月3日まで休診とさせていただきます。年始は1月4日より通常診療を開始いたします。ご不便をおかけいたしますが、何卒ご了承ください。',
    },
    {
      date: '2025.01.10',
      category: '診療情報',
      title: '新しいリハビリテーション機器を導入しました',
      content: '最新の物理療法機器を導入いたしました。より効果的な治療が可能になり、患者様の早期回復をサポートいたします。詳しくはスタッフまでお問い合わせください。',
    },
    {
      date: '2025.01.05',
      category: 'イベント',
      title: '健康セミナー開催のご案内',
      content: '腰痛予防をテーマとした無料セミナーを2月15日に開催いたします。日常生活でできる予防法や正しい姿勢について、わかりやすく解説いたします。参加ご希望の方はお電話にてお申し込みください。',
    },
    {
      date: '2024.12.20',
      category: 'お知らせ',
      title: 'インフルエンザ予防接種のお知らせ',
      content: 'インフルエンザ予防接種を実施しております。ご希望の方は事前にお電話でご予約ください。接種料金や詳細については、お問い合わせください。',
    },
    {
      date: '2024.12.10',
      category: '診療情報',
      title: '診療時間変更のお知らせ',
      content: '12月25日は午前診療のみとさせていただきます。午後は休診となりますので、ご注意ください。ご迷惑をおかけいたしますが、よろしくお願いいたします。',
    },
    {
      date: '2024.12.01',
      category: 'お知らせ',
      title: 'ホームページをリニューアルしました',
      content: 'より見やすく、使いやすいホームページにリニューアルいたしました。診療時間やアクセス情報など、必要な情報をすぐに見つけられるようになりました。',
    },
    {
      date: '2024.11.20',
      category: 'イベント',
      title: 'スポーツ障害予防セミナー開催報告',
      content: '11月15日に開催したスポーツ障害予防セミナーには、多くの方にご参加いただきました。ありがとうございました。次回の開催が決まりましたら、改めてお知らせいたします。',
    },
    {
      date: '2024.11.10',
      category: '診療情報',
      title: '骨密度測定検査のご案内',
      content: '骨粗鬆症の早期発見のため、骨密度測定検査を実施しております。特に50歳以上の女性の方は定期的な検査をおすすめします。ご希望の方はお気軽にご相談ください。',
    },
    {
      date: '2024.11.01',
      category: 'お知らせ',
      title: '駐車場の利用についてのお願い',
      content: '駐車場が満車の場合は、近隣のコインパーキングをご利用ください。また、クリニック前の道路への駐車はご遠慮いただきますようお願いいたします。',
    },
  ];

  const totalPages = Math.ceil(allNews.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentNews = allNews.slice(startIndex, startIndex + itemsPerPage);

  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'お知らせ':
        return 'bg-[#007bbb]/10 text-[#007bbb]';
      case '診療情報':
        return 'bg-green-100 text-green-700';
      case 'イベント':
        return 'bg-purple-100 text-purple-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };

  return (
    <section className="py-20 lg:py-32 bg-white px-6">
      <div className="max-w-5xl mx-auto">
        {/* News List */}
        <div className="space-y-8">
          {currentNews.map((item, index) => (
            <article
              key={index}
              className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow p-8 lg:p-10 border border-gray-100"
            >
              <div className="flex flex-col md:flex-row gap-6">
                {/* Date Badge */}
                <div className="flex-shrink-0">
                  <div className="w-20 h-20 bg-[#007bbb] rounded-xl flex flex-col items-center justify-center">
                    <span className="text-white text-xs font-medium">
                      {item.date.split('.')[0]}
                    </span>
                    <span className="text-white text-2xl font-bold leading-tight">
                      {item.date.split('.')[1]}.{item.date.split('.')[2]}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <span className={`inline-block text-xs font-medium px-3 py-1 rounded-full mb-3 ${getCategoryColor(item.category)}`}>
                    {item.category}
                  </span>
                  <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                    {item.title}
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    {item.content}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center space-x-2 mt-16">
            <button
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              className="w-12 h-12 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              aria-label="前のページ"
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`w-12 h-12 rounded-full flex items-center justify-center font-semibold transition-colors ${
                  currentPage === page
                    ? 'bg-[#007bbb] text-white'
                    : 'border border-gray-300 text-gray-700 hover:bg-gray-50'
                }`}
              >
                {page}
              </button>
            ))}

            <button
              onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              className="w-12 h-12 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              aria-label="次のページ"
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default NewsListSection;
